import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { hc } from 'hono/client';
import { firstValueFrom, map } from 'rxjs';

/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
function injectAngularHonoClient(options) {
  const http = inject(HttpClient);
  return hc(options.url, {
    fetch: async (input, requestInit, Environment, executionContext) => {
      let headers = new HttpHeaders();
      if (requestInit?.headers) {
        if (Array.isArray(requestInit.headers)) {
          for (const [header, value] of requestInit.headers) {
            headers = headers.set(header, value);
          }
        } else {
          for (const [header, value] of Object.entries(requestInit.headers)) {
            headers = headers.set(header, value);
          }
        }
      }
      const token = options.authToken?.();
      if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }
      return firstValueFrom(http.request(requestInit?.method ?? 'GET', input.toString(), {
        body: requestInit?.body && typeof requestInit.body === 'string' ? JSON.parse(requestInit.body) : requestInit?.body,
        responseType: 'text',
        observe: 'response',
        headers,
        withCredentials: options.withCredentials
      }).pipe(map(resp => {
        if (!resp.ok) {
          throw new Error(`HTTP Client ${resp.status} ${resp.statusText}`);
        }
        const respHeaders = {};
        for (const key of resp.headers.keys()) {
          respHeaders[key] = resp.headers.get(key) ?? '';
        }
        return new Response(resp.body, {
          status: resp.status,
          statusText: resp.statusText,
          headers: respHeaders
        });
      })));
    }
  });
}

/**
 * Generated bundle index. Do not edit.
 */

export { injectAngularHonoClient };
